// @ts-nocheck
const SettingsSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default SettingsSkeleton